// CustomDragLayer.tsx
import React from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';
import { LINE_ITEM_ROW_REORDER_TYPE } from '../components/project/rowReorder.util';

const layerStyles: React.CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 9999,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};

const getItemStyles = (currentOffset: XYCoord | null, gap: XYCoord): React.CSSProperties => {
  if (!currentOffset) return { display: 'none' };
  const { x, y } = currentOffset;

  return {
    position: 'fixed',
    top: y + gap.y,
    left: x + gap.x,
  };
};

const boxStyles: React.CSSProperties = {
  padding: '8px 12px',
  backgroundColor: 'rgba(2, 131, 160, 0.85)',
  color: '#fff',
  borderRadius: 6,
  fontWeight: 500,
  fontSize: '0.85rem',
  maxWidth: 240,
  transform: 'translateZ(0)', // Hint GPU
  willChange: 'transform',
};

const CustomDragLayer = () => {
  const { itemType, isDragging, item, currentOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getClientOffset(),
  }));

  const isRowReorder = itemType === LINE_ITEM_ROW_REORDER_TYPE;
  if (!isDragging || (itemType !== 'LINE_ITEM' && !isRowReorder)) return null;

  const count = (isRowReorder ? item.rowIds?.length : item.selectedRows?.length) || 1;
  const label = `${count} ${isRowReorder ? 'row' : 'item'}${count > 1 ? 's' : ''}`;

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(currentOffset, isRowReorder ? { x: 16, y: 12 } : { x: 50, y: 100 })}>
        <div style={boxStyles}>{label}</div>
      </div>
    </div>
  );
};

export default CustomDragLayer;
